module.exports = __webpack_public_path__ + "fontawesome-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 2871
// module chunks = 67